<!--the ROOT Component-->
<template>
  <div id="app">
    <top :user="user"></top>
    <router-view class="content"></router-view>
    <bottom></bottom>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Top from "./components/common/Top.vue";
import Bottom from "./components/common/Bottom.vue";

export default {
  computed: mapState({ user: (state) => state.user }),
  components: {
    Top,
    Bottom,
  },
};
</script>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}

.right_f {
  float: right;
  margin-right: 10px !important;
  margin-left: 0px !important;
}

#app .content {
  overflow: hidden;
  width: 100%;
  min-width: 1080px;
  min-height: calc(100% - 100px);
  padding-top: 60px;
}

.content .left-sidebar {
  background-color: rgb(239, 242, 247);
  float: left;
  width: 200px;
  margin-bottom: 20px;
}

#app .left-sidebar ul {
  height: 100%;
}

#app .router-link-active {
  color: #20a0ff;
}

#app .right-iframe {
  overflow-y: auto;
  position: relative;
  padding-bottom: 20px;
  z-index: 1;
}

#app .com-list {
  padding: 0 20px;
}

#top .el-menu-item {
  text-align: center;
}

#left-sidebar {
  height: calc(100vh - 100px);
  margin-bottom: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

/* 整个滚动条 */
#left-sidebar::-webkit-scrollbar {
  width: 10px;
  background-color: #eee;
}

/* 滚动条上的滚动滑块 */
#left-sidebar::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 12px;
}

/* 滚动条轨道 */
#left-sidebar::-webkit-scrollbar-track {
  background-color: #eee;
}

#right-iframe {
  height: calc(100vh - 100px) !important;
  overflow-y: auto;
  padding-bottom: 0 !important;
  min-height: unset !important;
}

/* 整个滚动条 */
#right-iframe::-webkit-scrollbar {
  width: 10px;
  background-color: #eee;
}

/* 滚动条上的滚动滑块 */
#right-iframe::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 12px;
}

/* 滚动条轨道 */
#right-iframe::-webkit-scrollbar-track {
  background-color: #eee;
}

.right-iframe .breadcrumb {
  position: relative;
  height: 36px;
  line-height: 36px;
  margin-top: 20px;
  margin-bottom: 20px;
  padding-right: 10px;
  background-color: #eee;
  text-indent: 20px;
  font-weight: bold;
  color: #1f2d3d;
  overflow: hidden;
}

.add {
  position: absolute;
}

.addCamp {
  right: 170px;
}

.selectSchool,
.selectUser {
  width: 100;
  margin-bottom: 20px;
  margin-left: 20px;
}

.selectSchool .selectInput,
.selectUser .selectInput {
  display: inline-block;
  width: 50%;
}

.selectSchool .searchBtn,
.selectUser .searchBtn {
  display: inline-block;
}

.warning {
  width: 100%;
  color: red;
  margin-bottom: 20px;
}

.uploadBtn {
  display: inline-block;
  position: absolute;
  right: -160px;
}

.fileLoad {
  background-color: #eee;
  margin-bottom: 20px;
}

.downLoadBtn {
  display: inline-block;
  margin-left: 200px;
}

.el-pagination {
  float: right;
  margin: 20px 20px 20px 0px;
}

.dialog-ruleForm {
  width: 560px;
}

.dialog-ruleForm .el-form-item:last-child {
  margin-bottom: 0;
}

.dialog-content {
  width: 430px;
}

.dialog-content .el-form-item {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// App.vue?2187710b